/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandOffice = createReactComponent("brand-office", "IconBrandOffice", [
  ["path", { d: "M4 18h9v-12l-5 2v5l-4 2v-8l9 -4l7 2v13l-7 3z", key: "svg-0" }]
]);

export { IconBrandOffice as default };
//# sourceMappingURL=IconBrandOffice.js.map
